import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const stack: SxStyle = {
  padding: (p) => p.spacing(1),
  borderRadius: (p) => p.spacing(0.5),
  background: (p) => p.palette.grey[200],
};

export const currentBalance: SxStyle = {
  '.credit-value': {
    color: (p) => p.palette.success[600],
  },
};
